import { render, staticRenderFns } from "./TestStudentHistoryHeader.vue?vue&type=template&id=436ee37e&scoped=true&lang=pug&"
import script from "./TestStudentHistoryHeader.vue?vue&type=script&lang=ts&"
export * from "./TestStudentHistoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TestStudentHistoryHeader.vue?vue&type=style&index=0&id=436ee37e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436ee37e",
  null
  
)

export default component.exports